<template>
    <div id="ResponsavelSelect">
        <select
            ref="responsavelSelect">
            <option value="" disabled selected>Selecione...</option>
            <option v-for="op in options"
                    :value="op.value">{{ op.texto }}
            </option>
        </select>
        <label>{{ label }}</label>
    </div>
</template>

<script>
    $(document).ready(function() {
        $('select').material_select();
    });

    export default {
        data: () => ({
            label: "Responsável pelo contato",
            options: [
                {value: '1', texto: "Joao"},
                {value: '2', texto: "Jose"},
                {value: '3', texto: "Maria"},
                {value: '4', texto: "Filipe"},
            ],
        }),
        mounted() {
            $(this.$refs.responsavelSelect).material_select()
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/lead/form/ResponsavelSelect.vue